<template>
  <div class="wysiwyg">
    <div v-if="filteredTopCertifications.length && !searchPhrase">
      <h2 class="h4 mb-40 mt-40">
        {{ $t('most_requested_certifications') }}
      </h2>
      <div class="cards">
        <Certification
          v-for="certification in filteredTopCertifications"
          :key="certification.id"
          :certification="certification"
        />
      </div>
    </div>

    <div v-if="!emptyResults">
      <h2 class="h4 mb-40 mt-40">
        {{ $t('all_certifications') }}
      </h2>
      <div class="cards">
        <Certification
          v-for="(certification, index) in filteredAllCertifications"
          :index="index"
          :key="certification.id"
          :certification="certification"
        />
      </div>
    </div>

    <div v-else-if="beforeInitialFetch || isLoading">
      <h2 class="h4 mt-40">
        {{ $t('loading') }}
      </h2>
    </div>

    <div v-else>
      <h2 class="h4 mt-40">
        {{ $t('not_found') }}
      </h2>
    </div>

    <div v-if="showMoreButton">
      <div class="tc mt-20 mt-10-md">
        <a
          class="btn btn-primary btn-icon btn-icon-sm"
          href="#"
          @click.prevent='showMoreCertifications'
        >
          {{ $t('next_certifications') }}
          <svg class="icon icon-arrow-right"><use xlink:href="#icons-arrow-right" /></svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  mapGetters as mapSearchGetters,
  getterTypes,
} from 'vuex-search';

import Certification from './Certification.vue';

export default {
  name: 'CertificationsList',
  props: ['defaultField'],
  data: () => ({
    filteredTopCertifications: [],
    filteredAllCertifications: [],
  }),

  watch: {
    resultIds() {
      this.filterCertificates();
    },
    getFilterField() {
      this.filterCertificates();
    },
  },
  computed: {
    ...mapSearchGetters('certifications', {
      resultIds: getterTypes.result,
      isLoading: getterTypes.isSearching,
    }),
    ...mapGetters({
      getCertifications: 'allCertifications',
      getTopCertifications: 'topCertifications',
      getFilterFulltext: 'getFilterFulltext',
      getFilterField: 'getFilterField',
      showAllCertifications: 'getShowAllCertifications',
      visibleItemsCount: 'getFilterVisibleItemsCount',
    }),
    ...mapState([
      'beforeInitialFetch',
    ]),
    searchPhrase() {
      return this.getFilterFulltext;
    },
    searchField() {
      return this.getFilterField;
    },
    emptyResults() {
      return this.filteredTopCertifications.length == 0 && this.filteredAllCertifications.length == 0;
    },
    showMoreButton() {
      return this.filteredAllCertifications.length > this.visibleItemsCount && this.showAllCertifications == false;
    },
  },
  methods: {
    filterCertificates() {
      let allCertifications = this.getCertifications;
      let topCertifications = this.getTopCertifications;

      if (this.searchPhrase !== '') {
        allCertifications = this.resultIds.map(id => allCertifications.find(obj => obj.id == id)).filter(item => item);
        topCertifications = this.resultIds.map(id => topCertifications.find(obj => obj.id == id)).filter(item => item);
      }
      if (this.searchField) {
        allCertifications = allCertifications.filter(obj =>
          obj.field_of_certifications.map(({ id }) => id).includes(this.searchField)
        );
        topCertifications = topCertifications.filter(obj =>
          obj.field_of_certifications.map(({ id }) => id).includes(this.searchField)
        );
      }


      this.filteredAllCertifications = allCertifications;
      this.filteredTopCertifications = topCertifications;
    },
    showMoreCertifications() {
      this.$store.dispatch('ShowAllCertifications', true);
    },
  },
  components: {
    Certification,
  },
};
</script>


<i18n>
{
  "cs": {
    "loading": "Načítám…",
    "next_certifications": "Další certifikace",
    "all_certifications": "Všechny certifikace",
    "not_found": "Nebyly nalezeny žádné certifikace",
    "most_requested_certifications": "Nejžádanější certifikace"
  },
  "en": {
    "loading": "Loading…",
    "most_requested_certifications": "The most requested certification",
    "not_found": "No certifications found",
    "all_certifications": "All certifications",
    "next_certifications": "Next certifications"
  },
  "it": {
    "loading": "Caricamento in corso…",
    "most_requested_certifications": "La certificazione più richiesta",
    "not_found": "Nessuna certificazione trovata",
    "all_certifications": "Tutte le certificazioni",
    "next_certifications": "Prossime certificazioni"
  }
}
</i18n>
